var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Main',{nativeOn:{"click":function($event){return _vm.resetTimeouts.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }